/**
 * Matches backend contractSignedForQr.subscriptionRequiresContractGate.
 */
export function subscriptionRequiresContract(product, subscription) {
  if (!product && !subscription) return false;
  const p = product || subscription?.product;
  if (!p) return !!subscription?.note?.mainSubscriptionId;

  // Coffee Pass members never sign the wash club agreement.
  if (p.vertical === "cafe") {
    return false;
  }

  if (subscription?.note?.mainSubscriptionId) {
    return true;
  }

  if (p.type === "package" || p.type === "onceoff") {
    return false;
  }

  if (p.type === "subscription") {
    return true;
  }

  return false;
}

/** Linked add-ons share the main membership contract — avoid duplicate signing modals in lists. */
export function isLinkedAddOnSubscription(subscription) {
  return !!(subscription?.note?.mainSubscriptionId);
}
